import React from 'react';
import { Eye, Target, TrendingUp, Shield, Globe } from 'lucide-react';

const AboutUs = () => {
  return (
    <section className="section-y bg-white">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-14 md:mb-16">
          <p className="section-kicker">Who we are</p>
          <h2 className="section-title">About Us</h2>
          <p className="section-subtitle">
            Leading logistics and maritime company dedicated to excellence in global trade
          </p>
        </div>

        {/* Company Story Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-16 md:mb-20">
          {/* Our Story */}
          <div className="card-surface bg-lightGray/80 p-8 border-lightGray">
            <div className="flex justify-center mb-4">
              <div className="bg-gradient-to-br from-navy to-teal p-3 rounded-full">
                <Globe size={32} className="text-white" />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-navy text-center mb-4">Our Story</h3>
            <p className="text-darkGray/70 leading-relaxed text-center">
              Infinity Enterprises, founded in 2023, is a leading logistics and maritime company that specializes in providing reliable and efficient shipping solutions for global trade and transportation. With a commitment to excellence, the company offers a wide range of products and services, including provisions, safety gear, marine chemicals, electrical stores, and much more.
            </p>
          </div>

          {/* Our Commitment */}
          <div className="card-surface bg-lightGray/80 p-8 border-lightGray">
            <div className="flex justify-center mb-4">
              <div className="bg-gradient-to-br from-navy to-teal p-3 rounded-full">
                <Shield size={32} className="text-white" />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-navy text-center mb-4">Our Commitment</h3>
            <p className="text-darkGray/70 leading-relaxed text-center">
              Leveraging decades of industry expertise, Infinity Enterprises ensures operational excellence by focusing on customer satisfaction, environmental sustainability, and cutting-edge technological innovations. The company operates with a core belief in integrity, pushing boundaries in technology, and delivering premium-quality services.
            </p>
          </div>

          {/* Our Future */}
          <div className="card-surface bg-lightGray/80 p-8 border-lightGray">
            <div className="flex justify-center mb-4">
              <div className="bg-gradient-to-br from-navy to-teal p-3 rounded-full">
                <TrendingUp size={32} className="text-white" />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-navy text-center mb-4">Our Future</h3>
            <p className="text-darkGray/70 leading-relaxed text-center">
              Backed by an experienced team of professionals, Infinity Enterprises aims to become a global leader in logistics and maritime solutions. The company's dedication to continuous growth and adaptation positions it as an industry innovator and a trusted partner in international trade.
            </p>
          </div>
        </div>

        {/* Vision & Mission */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {/* Vision */}
          <div className="card-surface bg-lightGray/80 p-8 border-lightGray">
            <div className="flex justify-center mb-4">
              <div className="bg-gradient-to-br from-navy to-teal p-3 rounded-full">
                <Eye size={32} className="text-white" />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-navy text-center mb-4">Our Vision</h3>
            <p className="text-darkGray/70 leading-relaxed text-center">
              To lead the global maritime and logistics industry through innovation, sustainability, and operational excellence, shaping the future of international trade with customer-centric solutions.
            </p>
          </div>

          {/* Mission */}
          <div className="card-surface bg-lightGray/80 p-8 border-lightGray">
            <div className="flex justify-center mb-4">
              <div className="bg-gradient-to-br from-navy to-teal p-3 rounded-full">
                <Target size={32} className="text-white" />
              </div>
            </div>
            <h3 className="text-2xl font-bold text-navy text-center mb-4">Our Mission</h3>
            <p className="text-darkGray/70 leading-relaxed text-center">
              To deliver world-class logistics solutions with a focus on quality, sustainability, and safety. We empower global businesses by providing reliable, efficient, and environmentally responsible shipping services.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;